<div class="add-equipment-node-dialog">
  <div class="detail-card-header">
    <span whFlex class="w-h-header-icon-span">
      <i
        mat-card-avatar
        class="workheld-icons header-icon"
        [innerHtml]="equipmentIcon"
      ></i>
    </span>
    <span whFlex class="w-h-header-span">
      <div class="single-header">
        {{ "equipment.model.root" | translate }}
      </div>
    </span>
  </div>
  <div class="add-equipment-node-dialog-body">
    <!--Search Side Bar-->
    <div class="flex-2 left">
      <ng-bee-list
        [focusElement]="true"
        [isMaterialIcon]="true"
        [icon]="equipmentIcon"
        name="EQUIPMENT"
        [columns]="columns"
        (filterChange)="onFilterChange($event)"
      >
        <div class="no-data" *ngIf="resultsLength === 0 && !fetchingEquipment">
          {{ "app.nodata.label" | translate }}
        </div>
        <mat-progress-bar
          *ngIf="fetchingEquipment"
          mode="query"
        ></mat-progress-bar>
        <mat-table class="data-table" #table [dataSource]="dataSource" matSort>
          <!-- ID Column -->
          <ng-container matColumnDef="id">
            <mat-header-cell
              class="image-cell"
              *matHeaderCellDef
            ></mat-header-cell>
            <mat-cell class="image-cell" *matCellDef="let row">
              <img
                alt="avatar"
                *ngIf="
                  row?.thumbnailURL &&
                  (row?.thumbnailURL
                    | WHImgAuthHeader: equipmentPlaceholderPNG
                    | async) as image
                "
                [src]="image"
                mat-card-avatar
                class="small-avatar"
                matTooltip="{{ row?.equipmentNumber + ' ' + row?.name }}"
              />
              <i
                *ngIf="!row.thumbnailURL"
                class="workheld-icons"
                [innerHTML]="equipmentIcon"
              ></i>
            </mat-cell>
          </ng-container>

          <!-- equipmentName Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ column.name | translate }}</mat-header-cell
            >
            <mat-cell *matCellDef="let row">
              <div class="html-overflow">
                {{ row.name }}
              </div>
            </mat-cell>
          </ng-container>

          <mat-row
            *matRowDef="let row; columns: visibleColumns"
            data-cy="select-equipment-row"
            (click)="selectEquipment(row)"
            (keydown.enter)="selectEquipment(row)"
            [ngClass]="{
              'selected-equipment': row.id === selectedEquipmentId,
            }"
          >
          </mat-row>
        </mat-table>
        <mat-paginator
          class="paginator wh-equipment-node-paginator"
          hidePageSize
          [length]="resultsLength"
          [pageSize]="pageSize"
        >
        </mat-paginator>
      </ng-bee-list>
    </div>
    <!-- Equipment Node Selector-->
    <div class="flex-6 right">
      <div class="bomstructure-wrapper flex-1">
        @if (bomnodesLoading) {
          <div class="no-data">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        } @else if (!selectedEquipmentId) {
          <div class="no-data">
            {{ "equipmentplanner.selectequipment.label" | translate }}
          </div>
        } @else {
          <app-equipment-structure
            [rootBomNodeId]="equipmentStore.currentNode()?.id"
            [hasSkillManagementEnabled]="false"
            [includeDecommissioned]="false"
            [maxDepth]="25"
            [enableSearch]="true"
            [baseWidth]="54"
            [showNodeId]="true"
            [isModalView]="true"
            [showInactiveChildren]="false"
            (handleNodeMenuClick)="handleNodeMenuClick($event)"
          ></app-equipment-structure>
        }
      </div>
      <div class="flex--r-c-fe gap--8 p--16">
        <w-h-button
          [text]="'app.cancel.label' | translate | uppercase"
          matIcon="close"
          type="stroked"
          (clicked)="cancel()"
        />
        <w-h-button
          [text]="'app.assign.label' | translate | uppercase"
          [isLoading]="assigningBomNode"
          color="accent"
          type="flat"
          [disabled]="!selectedBomNode"
          dataCy="assign-bomnode-button"
          (clicked)="confirm()"
        />
      </div>
    </div>
  </div>
</div>
